import yaml from 'js-yaml';

export const validateYAMLConfig = (yamlConfig: string) => {
	try {
		yaml.load(yamlConfig);
	} catch (error) {
		const errorMessage = `${error.name}: ${error.reason} (${error.mark.line + 1}:${
			error.mark.column + 1
		})`;
		throw new Error(errorMessage);
	}
};
